module.exports = __webpack_public_path__ + "static/img/10.19ab212.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/10.png
// module id = Q2MO
// module chunks = 0